import React from "react"
import PropTypes from "prop-types"
import { Card, CardBody } from "reactstrap"

const Birthchart = ({ birthChart }) => {
  var imageSrc = "data:image/png;base64," + birthChart.chartImage;
  return (
    <Card>
      <CardBody>
        <div className="text-center">
          <img id="ItemPreview" src={imageSrc} />
        </div>
      </CardBody>
    </Card>
  )
}

Birthchart.propTypes = {
  project: PropTypes.object,
}

export default Birthchart
